import "swiper/swiper-bundle.css";
import "glightbox/dist/css/glightbox.min.css";

import {
	Autoplay,
	EffectFade,
	FreeMode,
	Mousewheel,
	Pagination,
	Thumbs,
} from "swiper/modules";

import GLightbox from "glightbox";
import Swiper from "swiper";

Array.from(
	document.querySelectorAll(
		"main#accommodation .suggested-accommodation.swiper"
	)
).map((video) => {
	const swiper = new Swiper(video, {
		modules: [Pagination, FreeMode, Mousewheel],
		slidesPerView: 1.25,
		spaceBetween: 16,
		freeMode: true,
		mousewheel: false,
		grabCursor: false,
		pagination: {
			el: video.querySelector(".swiper-pagination"),
			type: "progressbar",
		},
		autoHeight: true,
		breakpoints: {
			768: {
				slidesPerView: 2.5,
			},
		},
	});
});

Array.from(document.querySelectorAll(".accommodation-gallery.swiper")).map(
	(gallery) => {
		const parent = gallery?.closest(".js-gallery-wrapper");
		const thumbnails = parent?.querySelector(
			".accommodation-swiper--thumbnails.swiper"
		);
		let thumbnailSwiper = false;

		if (thumbnails) {
			thumbnailSwiper = new Swiper(thumbnails, {
				modules: [Pagination, FreeMode, Mousewheel],
				autoHeight: true,
				loop: false,
				spaceBetween: 12,
				slidesPerView: 2.75,
				freeMode: true,
				watchSlidesProgress: true,
				mousewheel: false,
				grabCursor: false,
				pagination: {
					el: thumbnails.querySelector(".swiper-pagination"),
					type: "progressbar",
				},
			});
		}

		const swiper = new Swiper(gallery, {
			modules: [Autoplay, Pagination, EffectFade, Thumbs],
			effect: "fade",
			fadeEffect: {
				crossFade: true,
			},
			autoplay: {
				delay: 7500,
			},
			loop: true,
			thumbs: {
				swiper: thumbnailSwiper ? thumbnailSwiper : false,
			},
		});

		const lightbox = GLightbox();

		lightbox.on("slide_changed", () => {
			swiper?.slideTo(lightbox?.index);
		});
	}
);
